import React from "react";
// import {Row, Col,Card, CardBody, CardHeader} from "reactstrap";
import SummeryPieChart from "./summery-pie-chart";
export const RecordSummeryBox = ({ recordingData, reportDates }) => {
    const { measuring_time, measuring_time_percentage, off_wrist_duration, off_wrist_duration_percentage, total_time } = recordingData;
    const data = [{ name: 'measuring_time', value: measuring_time_percentage }, { name: 'off_wrist', value: off_wrist_duration_percentage }];
    return (React.createElement("div", { className: "card page-break" },
        React.createElement("div", { className: "bg-transparent card-header" },
            React.createElement("div", { className: "row header-card" },
                React.createElement("div", { className: "col-3 text-start" }, "Recording Summary"),
                React.createElement("div", { className: "col-sm-9 text-end" },
                    "from ",
                    reportDates.fromDate,
                    " to ",
                    reportDates.toDate))),
        React.createElement("div", { className: "card-body" },
            React.createElement("div", { className: "d-flex justify-content-center" },
                React.createElement("div", { className: "flex-max" },
                    React.createElement(SummeryPieChart, { data: data })),
                React.createElement("div", { className: "flex-max pt-5 ml-n-2" },
                    React.createElement("div", { className: "green-team fs-1 weight-3" }, `${measuring_time_percentage}% Measuring Time`),
                    React.createElement("div", { className: "grey-team fs-1 weight-3 pt-3" }, `${off_wrist_duration_percentage}% Off-Wrist`),
                    React.createElement("div", { className: "blue-team fs-1 weight-3 pt-3" }, "Total Recording Time")),
                React.createElement("div", { className: "flex-max pt-5 ml-3" },
                    React.createElement("div", { className: "grey-team fs-1 weight-3" },
                        measuring_time,
                        " Hr"),
                    React.createElement("div", { className: "grey-team fs-1 weight-3 pt-3" },
                        off_wrist_duration,
                        " Hr"),
                    React.createElement("div", { className: "grey-team fs-1 weight-3 pt-3" },
                        off_wrist_duration + measuring_time,
                        " Hr"))))));
};
